import MApp from "./MApp";

export default class MModal
{
	constructor(el)
	{
		this.el = el;

		if (!this.el.dataset.mModalInitd) {
			this.addEventListeners();
			this.el.dataset.mModalInitd = 1;
		}
	}

	addEventListeners()
	{
		document.addEventListener("keyup", event => {
			if (event.key === "Escape") {
				MModal.closeAll();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.tagName == "HTML" || event.target.matches(".modal") || event.target.matches(".modal__close-button")) {
				MModal.closeAll();
			}
		});
	}

	open()
	{
		document.querySelector("body").classList.add("noscroll");

		let clonedModal = this.el.cloneNode(true);
		this.el.parentElement.append(clonedModal);
		clonedModal.classList.add("modal--visible");
		MApp.refresh();

		try {
			clonedModal.querySelector(".focus:visible").focus();
		} catch (error) {
			// Nevermind.
		}
	};

	close()
	{
		document.querySelector("body").classList.remove("noscroll");
		this.el.remove();
	}

	static closeAll()
	{
		document.querySelector("body").classList.remove("noscroll");
		document.querySelectorAll(".modal--visible").forEach(el => {
			(new MModal(el)).close();
		});
	}
}
